import Product from "../../../../../../@types/Product";

const Tops: Product[] = [
    {
        id: 1,
        name: '84″ RedDot® Versa Triple Track Top - Black',
        sku: '26-152-X',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/07/canopy-black-web-sized.png'
    },
];

export default Tops;